import { ThemeProvider as NextThemesProvider } from "next-themes";
import "./font.css";
import UserRoutes from "./routes/UserRoutes";
import { NextThemeConfigProvider } from "./themes";
function App() {
  return (
    // `defaultTheme="dark"` makes dark mode the default for first-time
    // visitors (no stored preference). An explicit choice in the settings
    // drawer still wins and is remembered.
    <NextThemesProvider defaultTheme="dark">
      <NextThemeConfigProvider>
        <UserRoutes />
      </NextThemeConfigProvider>
    </NextThemesProvider>
  );
}

export default App;
